export default {
      id: "huge-print-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#huge-print",
      toString: function () {
        return this.url;
      }
    }